import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function documentApi(path: string) {
  return {
    path,
    GET: () => api.get<JsonApiResponseSingle>(path),
  };
}
